import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectRectanlgeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 19.75C21.59 19.75 21.25 20.09 21.25 20.5V21.25H20.5C20.09 21.25 19.75 21.59 19.75 22C19.75 22.41 20.09 22.75 20.5 22.75H22C22.41 22.75 22.75 22.41 22.75 22V20.5C22.75 20.09 22.41 19.75 22 19.75Z"
        fill={color}
      />
      <path
        d="M10.3 21.25H6.89999C6.48999 21.25 6.14999 21.59 6.14999 22C6.14999 22.41 6.48999 22.75 6.89999 22.75H10.3C10.71 22.75 11.05 22.41 11.05 22C11.05 21.59 10.71 21.25 10.3 21.25Z"
        fill={color}
      />
      <path
        d="M17.1 21.25H13.7C13.29 21.25 12.95 21.59 12.95 22C12.95 22.41 13.29 22.75 13.7 22.75H17.1C17.51 22.75 17.85 22.41 17.85 22C17.85 21.59 17.51 21.25 17.1 21.25Z"
        fill={color}
      />
      <path
        d="M3.5 21.25H2.75V20.5C2.75 20.09 2.41 19.75 2 19.75C1.59 19.75 1.25 20.09 1.25 20.5V22C1.25 22.41 1.59 22.75 2 22.75H3.5C3.91 22.75 4.25 22.41 4.25 22C4.25 21.59 3.91 21.25 3.5 21.25Z"
        fill={color}
      />
      <path
        d="M2 11.05C2.41 11.05 2.75 10.71 2.75 10.3V6.89999C2.75 6.48999 2.41 6.14999 2 6.14999C1.59 6.14999 1.25 6.48999 1.25 6.89999V10.3C1.25 10.71 1.59 11.05 2 11.05Z"
        fill={color}
      />
      <path
        d="M2 17.85C2.41 17.85 2.75 17.51 2.75 17.1V13.7C2.75 13.29 2.41 12.95 2 12.95C1.59 12.95 1.25 13.29 1.25 13.7V17.1C1.25 17.51 1.59 17.85 2 17.85Z"
        fill={color}
      />
      <path
        d="M3.5 1.25H2C1.59 1.25 1.25 1.59 1.25 2V3.5C1.25 3.91 1.59 4.25 2 4.25C2.41 4.25 2.75 3.91 2.75 3.5V2.75H3.5C3.91 2.75 4.25 2.41 4.25 2C4.25 1.59 3.91 1.25 3.5 1.25Z"
        fill={color}
      />
      <path
        d="M10.3 1.25H6.89999C6.48999 1.25 6.14999 1.59 6.14999 2C6.14999 2.41 6.48999 2.75 6.89999 2.75H10.3C10.71 2.75 11.05 2.41 11.05 2C11.05 1.59 10.71 1.25 10.3 1.25Z"
        fill={color}
      />
      <path
        d="M17.1 1.25H13.7C13.29 1.25 12.95 1.59 12.95 2C12.95 2.41 13.29 2.75 13.7 2.75H17.1C17.51 2.75 17.85 2.41 17.85 2C17.85 1.59 17.51 1.25 17.1 1.25Z"
        fill={color}
      />
      <path
        d="M22 1.25H20.5C20.09 1.25 19.75 1.59 19.75 2C19.75 2.41 20.09 2.75 20.5 2.75H21.25V3.5C21.25 3.91 21.59 4.25 22 4.25C22.41 4.25 22.75 3.91 22.75 3.5V2C22.75 1.59 22.41 1.25 22 1.25Z"
        fill={color}
      />
      <path
        d="M22 12.95C21.59 12.95 21.25 13.29 21.25 13.7V17.1C21.25 17.51 21.59 17.85 22 17.85C22.41 17.85 22.75 17.51 22.75 17.1V13.7C22.75 13.29 22.41 12.95 22 12.95Z"
        fill={color}
      />
      <path
        d="M22 6.14999C21.59 6.14999 21.25 6.48999 21.25 6.89999V10.3C21.25 10.71 21.59 11.05 22 11.05C22.41 11.05 22.75 10.71 22.75 10.3V6.89999C22.75 6.48999 22.41 6.14999 22 6.14999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectRectanlgeIcon.displayName = 'SelectRectanlgeIcon';
